import React, { FunctionComponent } from 'react';
import { Col, Row } from '@visalex/core';

import cx from 'clsx';
import Image from 'next/image';

import { VisaPageProcessStep } from '../../VisaPage';

import styles from './ListItem.module.scss';

type ListItemProps = {
  step: VisaPageProcessStep;
  positionNumber: number;
  isLast: boolean;
  withDottedLines?: boolean;
};
const ListItem: FunctionComponent<ListItemProps> = ({ step, positionNumber, isLast }) => {
  return (
    <Row>
      <Col xs={3} md={12} className={styles['list-item__image-wrapper']}>
        {(positionNumber === 2 || positionNumber === 4) && (
          <hr className={cx(styles['list-item__dotted-line'], styles['list-item__dotted-pre-line-lg'])} />
        )}
        {positionNumber === 3 && (
          <hr className={cx(styles['list-item__dotted-line'], styles['list-item__dotted-pre-line-xl'])} />
        )}
        <Image className={styles['list-item__image']} src={step.imageUrl} alt={step.imageAlt} width={90} height={90} />
        {!isLast && (
          <hr
            className={cx(
              styles['list-item__dotted-line'],
              (positionNumber === 1 || positionNumber === 3) && styles['list-item__dotted-line_lg-max'],
              positionNumber === 2 && styles['list-item__dotted-line_xl-max']
            )}
          />
        )}
      </Col>
      <Col xs={8} md={12} className={styles['list-item__info']}>
        <div className={styles['list-item__title']}>{step.title}</div>
        <p className={styles['list-item__description']}>{step.description}</p>
      </Col>
    </Row>
  );
};

export default ListItem;
